import React from 'react';
import styled from 'styled-components';
import { useStatus } from '../../../shared/contexts/StatusContext';

const Banner = styled.div<{ $isOpen: boolean }>`
  padding: 10px 0px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: ${props => props.$isOpen ? '#10b981' : '#ef4444'};

  i {
    font-size: 14px;
  }
`;

const StatusMessage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
`;

const MainText = styled.span`
  font-weight: 600;
  font-size: 14px;
`;

const SubText = styled.span`
  font-weight: 500;
  font-size: 12px;
  opacity: 0.8;
`;

export const StatusBanner: React.FC = () => {
  const { isOpen, message, status } = useStatus();

  if (!status) return null;

  const getNextOpenInfo = () => {
    if (isOpen || !status.nextOpen) return null;

    const { day, time } = status.nextOpen;
    
    // Tradução dos dias
    const dayTranslations: Record<string, string> = {
      'monday': 'Segunda-feira',
      'tuesday': 'Terça-feira',
      'wednesday': 'Quarta-feira',
      'thursday': 'Quinta-feira',
      'friday': 'Sexta-feira',
      'saturday': 'Sábado',
      'sunday': 'Domingo',
      'today': 'Hoje'
    };

    // Se o dia for "today" ou for hoje
    const isToday = day.toLowerCase() === 'today';
    
    if (isToday) {
      return `Abriremos Hoje às ${time}`;
    }

    const dayName = dayTranslations[day.toLowerCase()] || day;
    return `Abriremos ${dayName} às ${time}`;
  };

  const nextOpenInfo = getNextOpenInfo();

  return (
    <Banner $isOpen={isOpen}>
      <i className={`fas ${isOpen ? 'fa-check-circle' : 'fa-clock'}`}></i>
      <StatusMessage>
        <MainText>{isOpen ? 'Estamos Abertos!' : 'Estamos Fechados'}</MainText>
        {nextOpenInfo && <SubText>{nextOpenInfo}</SubText>}
      </StatusMessage>
    </Banner>
  );
};
